import React from "react";
import { stripIndent } from "common-tags";

export function getTagManager({ id, optimizeId }: { id: string; optimizeId: string }): ReadonlyArray<React.ReactNode> {
    return [
        <script key={`gtm-data`}>{stripIndent`
            window.dataLayer = window.dataLayer || [];
          `}</script>,
        <script key={`analytics-setup`}>{stripIndent`
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
          `}</script>,
        <style key={`optimize-asyncHide-style`}>{stripIndent`
            .async-hide { opacity: 0 !important }
          `}</style>,
        <script key={`optimize-asyncHide-script`}>{stripIndent`
              (function(a,s,y,n,c,h,i,d,e){s.className+=' '+y;h.start=1*new Date;
              h.end=i=function(){s.className=s.className.replace(RegExp(' ?'+y),'')};
              (a[n]=a[n]||[]).hide=h;setTimeout(function(){i();h.end=null},c);h.timeout=c;
              })(window,document.documentElement,'async-hide','dataLayer',5000,{'${id}':true});
            `}</script>,
        <script key={`analytics-script`}>{stripIndent`
            gtag('config', '${id}', { 'optimize_id': '${optimizeId}'});
          `}</script>,
        <script key={`gtm-script`}>{stripIndent`
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl+'';f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer', '${id}');`}</script>,
    ];
}
